import { render } from "./B2bPageFacturaRecibida.vue?vue&type=template&id=289b8e82&scoped=true&lang=pug"
import script from "./B2bPageFacturaRecibida.vue?vue&type=script&lang=js"
export * from "./B2bPageFacturaRecibida.vue?vue&type=script&lang=js"

import "./B2bPageFacturaRecibida.vue?vue&type=style&index=0&id=289b8e82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289b8e82"]])

export default __exports__